import React from "react";
import DialogBox from "./dialog-box";

const UploadSkillImage = () => {
  return (
    <React.Fragment>
      <DialogBox />
    </React.Fragment>
  );
};

export default UploadSkillImage;
